angular.module('core').filter('translate', ['translationService', '$locale', function(translationService, $locale) {
    var FALLBACK_LOCALE = 'en-us';

    function getNestedValue(translations, key) {
        if (!translations || !key) {
            return undefined;
        }

        try {
            var translationFromKey = function(key, currentObject) {
              if (currentObject[key] && typeof currentObject[key] === 'string') {
                // If using the full key results in a string, use the full key (handles keys that contain a full stop).
                return currentObject[key];
              }

              // Otherwise, split the string from it's first full stop.
              var idx = key.indexOf('.');
              var keys = idx === -1 ? [key] : [key.substring(0, idx), key.substring(idx + 1)];

              if (typeof currentObject[keys[0]] === 'object' && keys.length > 1) {
                return translationFromKey(keys[1], currentObject[keys[0]]);
              }

              return currentObject[keys[0]];
            };

            return translationFromKey(key, translations);
        } catch (e) {
            console.warn('Translation error for key:', key);
            return undefined;
        }
    }

    function replacePlaceholders(value, options) {
        if (typeof value !== 'string') {
            return value;
        }
        if (!options || typeof options !== 'object' || Array.isArray(options)) {
            return value;
        }
        return Object.keys(options || {}).reduce(function(result, optKey) {
            return result.replace(new RegExp('{{' + optKey + '}}', 'g'), options[optKey]);
        }, value);
    }

    function getTranslationForLocale(locale, key, options) {
        if (!translationService.isTranslationsLoaded(locale)) {
            return '';
        }

        var translations = translationService.getTranslations(locale);
        var translation = null;

        // Modify the key for pluralization if 'count' is provided in options
        if (Object.keys(options || {}).indexOf('count') > -1) {
            var pluralKey = key + (options.count === 1 ? '_one' : '_other');
            translation = getNestedValue(translations, pluralKey);
        }

        if (!translation) {
            translation = getNestedValue(translations, key);
        }

        return translation;
    }

    var translateFilter = function(key, options) {
        // Attempt to get the translation for the current locale.
        var translation = getTranslationForLocale($locale.id, key, options);

        if (!translation && $locale.id !== FALLBACK_LOCALE) {
            // Attempt to use the fallback locale
            translation = getTranslationForLocale(FALLBACK_LOCALE, key, options);
        }

        if (!translation) {
            // Use either the default value or the key, if the translation can't be found
            translation = (Object.keys(options || {}).indexOf('defaultValue') > -1) ? options.defaultValue : key;
        }

        // Replace placeholders.
        if (options) {
            translation = replacePlaceholders(translation, options);
        }
        return translation;
    };

    // Mark filter as stateful so it re-evaluates when translations load
    translateFilter.$stateful = true;

    return translateFilter;
}]);
